module.exports = __webpack_public_path__ + "img/code.ea8122b8.jpg";